import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompany = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 21V3H11.8333V7.08325H22V21H2ZM3.66675 19.3333H6.08325V16.9168H3.66675V19.3333ZM3.66675 15.25H6.08325V12.8333H3.66675V15.25ZM3.66675 11.1667H6.08325V8.75H3.66675V11.1667ZM3.66675 7.08325H6.08325V4.66675H3.66675V7.08325ZM7.75 19.3333H10.1668V16.9168H7.75V19.3333ZM7.75 15.25H10.1668V12.8333H7.75V15.25ZM7.75 11.1667H10.1668V8.75H7.75V11.1667ZM7.75 7.08325H10.1668V4.66675H7.75V7.08325ZM11.8333 19.3333H20.3333V8.75H11.8333V11.1667H13.8333V12.8333H11.8333V15.25H13.8333V16.9168H11.8333V19.3333ZM16.25 12.8333V11.1667H17.9168V12.8333H16.25ZM16.25 16.9168V15.25H17.9168V16.9168H16.25Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCompany);
export default ForwardRef;
